import { connect } from 'react-redux'
import ContributionModal from './contribution-modal'
import {
  getSubmitContributionRequest,
  getCurrentConclusion
} from '../../../../../../../stores/discussion/discussion.selectors'
import { getAssessmentFileConclusionState } from '../../../../../../../stores/assessment-file/assessment-file.selectors'
import { submitContribution } from '../../../../../../../stores/discussion/discussion.actions'
import { withRouter } from 'react-router-dom'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapStateToProps = (state, { match }) => {
  const currentConclusion = getCurrentConclusion(state)
  return {
    id: match.params.assessmentFileId,
    posting: getSubmitContributionRequest(state).pending,
    currentConclusion: currentConclusion && currentConclusion.id,
    isConcluded: getAssessmentFileConclusionState(state)
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...stateProps,
  ...ownProps,
  onSubmit: (id, contribution) => {
    dispatch(
      submitContribution(id, stateProps.currentConclusion, {
        content: contribution
      })
    ).catch(errorHandler)
  }
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
  )(ContributionModal)
)
